import { GetAllV2TeamServiceTiersQuery } from "lib/types/graphql";
import { PricingCardContent } from "./PricingCardContent";
import styles from "./PricingCards.module.css";
import cn from "classnames";
import { useState } from "react";
import { TableFooter } from "./TableFooter";
import { CreditsExplained } from "./CreditsExplained";
import { ButtonSubscribeFromPricing } from "./ButtonSubscribeFromPricing";
import { ButtonSubscribeFromNewTeam } from "./ButtonSubscribeFromNewTeam";

export type Origin = Props["origin"];

type Props =
  | {
      teamServiceTiers: GetAllV2TeamServiceTiersQuery["team_service_tiers"];
      origin: "pricing";
      onCardOpen: () => void;
    }
  | {
      teamServiceTiers: GetAllV2TeamServiceTiersQuery["team_service_tiers"];
      origin: "new_team";
      teamHandle: string;
    };

export const PricingCards = (props: Props) => {
  const { teamServiceTiers, origin } = props;
  const [isCardOpen, setIsCardOpen] = useState(origin === "new_team" ?? false);
  const onDropdownClick = () =>
    props.origin === "pricing"
      ? props.onCardOpen()
      : setIsCardOpen((isOpen) => !isOpen);

  return (
    <>
      <div
        className={cn(styles.table, styles[`origin-${origin}`])}
        id="pricing-table"
      >
        <div className={cn(styles.cards, styles[`origin-${origin}`])}>
          {teamServiceTiers?.map((serviceTier) => (
            <PricingCardContent
              key={serviceTier.name}
              serviceTier={serviceTier}
              isCardOpen={isCardOpen}
              setIsCardOpen={setIsCardOpen}
              onDropdownClick={onDropdownClick}
              origin={origin}
              badgeText={
                origin === "pricing" && serviceTier.id !== 1
                  ? "For teams"
                  : undefined
              }
              button={
                origin === "pricing" ? (
                  <ButtonSubscribeFromPricing plan={serviceTier} />
                ) : (
                  <ButtonSubscribeFromNewTeam
                    plan={serviceTier}
                    teamHandle={props.teamHandle}
                  />
                )
              }
            />
          ))}
        </div>
        <TableFooter />
      </div>
      <CreditsExplained origin={origin} />
    </>
  );
};
